import React from 'react'

import Container from 'common/Container'
import Footer from 'common/Footer'
import Nav from 'common/Nav'

const Investor = () => (
    <>
        <Nav />
        <Container>
            <p>This feature is not available</p>
        </Container>
        <Footer />
    </>
)

export default Investor
